import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerNonBpMerchantInfoApiCallSuccess } from 'redux/actions';
import { TRIGGER_NON_BP_MERCHANT_INFO_API } from 'redux/actionTypes';
import { apiCall } from 'services';
import { nativeHandler } from 'utils';

function* triggerNonBpMerchantInfoApiCall(actions) {
	const { data, callback } = actions;
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url: API_CONSTANT.URL.NON_BP_MERCHANT_INFO,
		data,
		method: 'POST',
		options: {
			dontRemoveLoader: true,
			restrictToast: true,
		},
		loaderDetails: {
			first_message: 'verifying',
			start_index: 0,
			range: 9,
			second_message: '',
		},
	});
	if (api && api.data) {
		if (api.data.statusCode === '200') {
			const apiData = api.data;
			callback && callback(apiData);
			yield put(triggerNonBpMerchantInfoApiCallSuccess(apiData));
		} else {
			callback && callback('error');
			nativeHandler.removeLoader();
		}
	}
}

export default function* triggerNonBpMerchantInfoApiCallSaga() {
	yield takeEvery(TRIGGER_NON_BP_MERCHANT_INFO_API, triggerNonBpMerchantInfoApiCall);
}
